<script>
    import SimpleImageTile from "./SimpleImageTile.svelte";
    import clickTracker from "../tracking/clickTracker.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        recommendation,
        lazyLoad,
        cinemaTracking,
        featureIndex,
        cinemaIndex,
        cinemaMeta,
        additionalCinemaClickTracking,
        additionalNextPiTrackingLabels = null,
        additionalTrackingLabels = null,
    } = $props();

    const {
        image,
        tracking,
        _embedded: { "o:variation": variation },
    } = $derived(recommendation);

    const baseDetailViewUrl = $derived(variation._links["o:base-detail-view-url"]?.href);
    const variationDetailViewUrl = $derived(variation._links["o:detail-view"]?.href);
    const conditionalBaseDetailViewUrl = $derived(!baseDetailViewUrl ? {} : { href: baseDetailViewUrl });

    const clickHandler = () => {
        clickTracker({
            cinemaTracking,
            recommendationTracking: tracking,
            featureIndex,
            cinemaIndex,
            additionalCinemaClickTracking,
            additionalRecommendationClickTracking: recommendation.additionalClickTracking,
            cinemaMeta,
            recommendationMeta: recommendation.meta,
            additionalTrackingLabels,
            additionalNextPiTrackingLabels,
        });
    };
</script>

<div data-qa="slidingCinemaPromotion" class="reco_simple_cinema__tile">
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <oc-link-v2 base64-href={btoa(variationDetailViewUrl)} onclick={clickHandler} data-testId="simple-reco-card">
        <a class="reco_simple_cinema__adslink" {...conditionalBaseDetailViewUrl}>
            <oc-card-v3>
                <SimpleImageTile {image} {lazyLoad} />
            </oc-card-v3>
        </a>
    </oc-link-v2>
</div>

<style lang="scss">
    .reco_simple_cinema__tile {
        width: 96px;
        height: 96px;
    }

    oc-card-v3::part(overflow-for-elevation) {
        border-radius: 8px;
    }
</style>
